import { generateRecurringBookingConfirmPaymentDTO, generateRecurringOrderBookingsDTO } from 'components/RecurringBookings'
import { calculateCouponTotalAmount, CouponApiResponse } from 'types/coupon'
import { IntakeClientResponse, IntakeResponseDTO, mapClientResponseToDTO } from 'types/intake-forms'
import { OrderType } from 'types/order'
import { BookingConfirmPaymentWithoutBookingDTO, BookingDTO, OrderBookingWithoutBookingDTO, OrderDTO, RecurringBookingDates } from 'types/order-booking'
import { postApiRequest } from 'utils/fetch-helper'
import { toHHMM12, toYmd } from 'utils/string-localization-helper'

export async function payForAppointment(
    amount: number,
    paymentMethodId: string,
    clientEmail: string,
    clientFirstName: string,
    clientLastName: string,
    clientPhone: string,
    clientTimezone: string,
    start_at: Date,
    finish_at: Date,
    serviceId: string,
    tenantId: string,
    locationId: string,
    staff_availability_id: string | undefined,
    couponCode: string = '',
    is_recurring?: boolean,
    recurring_dates?: RecurringBookingDates[],
    duration?: number,
    valid_recurring_count: number = 1,
    client_responses?: IntakeClientResponse[],
    coupon?: CouponApiResponse //TODO: map this value whereever it's coming from
) {
    const client_dto = {
        clientEmail,
        clientFirstName,
        clientLastName,
        clientPhone,
        clientTimezone,
    }
    const savePaymentMethod = localStorage.getItem('save_card') == 'true'
    let total_amount
    if (coupon) {
        total_amount = calculateCouponTotalAmount(amount, coupon, valid_recurring_count)
    } else {
        total_amount = amount * valid_recurring_count
    }
    const paymentMethod = total_amount > 0 ? 'CARD' : ''
    if (is_recurring) {
        return await postApiRequest('/v1/payments/confirm-booking-payment-from-list', generateRecurringBookingConfirmPaymentDTO({
            amount: total_amount,
            order: {
                clientEmail,
                clientFirstName,
                clientLastName,
                clientPhone,
                tenantId,
                type: OrderType.SERVICE,
                couponCode: couponCode,
                fullyPaid: false,
                paymentMethod,
                paymentMethodId,
            } as OrderDTO,
            tenantId,
            savePaymentMethod,
            paymentMethodId
        } as BookingConfirmPaymentWithoutBookingDTO,
        {
            appointmentDto: {
                date: toYmd(start_at),
                endTime: toHHMM12(finish_at),
                startTime: toHHMM12(start_at),
                serviceId,
                locationId,
                tenantId,
                staffAvailabilityId: staff_availability_id
            },
            clientEmail,
            tenantId,
        } as BookingDTO, recurring_dates || [], duration || 0, client_responses))
    } else {
        return await postApiRequest(
            `/v1/payments/confirm-booking-payment`,
            {
                amount: total_amount,
                savePaymentMethod,
                booking: {
                    ...client_dto,
                    appointmentDto: {
                        date: toYmd(start_at),
                        endTime: toHHMM12(finish_at),
                        startTime: toHHMM12(start_at),
                        serviceId,
                        locationId: locationId ? locationId : undefined,
                        tenantId,
                        staffAvailabilityId: staff_availability_id
                    },
                    tenantId,
                },
                paymentMethodId,
                tenantId,
                locationId: locationId ? locationId : undefined,
                order: {
                    ...client_dto,
                    tenantId,
                    paymentMethod,
                    paymentMethodId,
                    type: OrderType.SERVICE,
                    couponCode: couponCode,
                },
                responses: client_responses?.map(mapClientResponseToDTO)
            }
        )
    }


}

export const bookingAppointmentUsingCoupon = async ({
    amount,
    tenantId,
    locationId,
    clientEmail,
    order,
    booking,
    responses
}: {
    amount: number
    tenantId: string
    locationId: string
    clientEmail: string
    order: any
    booking: any
    responses?: IntakeResponseDTO[]
}) => {
    return await postApiRequest(
        '/v1/orders/order-booking?sendNotification=true',
        {
            amount,
            tenantId,
            locationId,
            clientEmail,
            order,
            booking,
            responses
        }
    )
}

export async function bookAppointmentUsingMembership(
    membershipClientId: string,
    clientEmail: string,
    clientFirstName: string,
    clientLastName: string,
    clientPhone: string,
    tenantId: string,
    serviceId: string,
    locationId: string,
    staff_availability_id: string | undefined,
    start_at: Date,
    finish_at: Date,
    is_recurring?: boolean,
    recurring_dates?: RecurringBookingDates[],
    duration?: number,
    client_responses?: IntakeClientResponse[]
) {
    if (is_recurring) {
        return await postApiRequest('/v1/orders/order-booking-from-list', generateRecurringOrderBookingsDTO({
            order: {
                clientEmail,
                clientFirstName,
                clientLastName,
                clientPhone,
                tenantId,
                membershipClientId,
                type: OrderType.SERVICE,
                couponCode: '',
                fullyPaid: false
            } as OrderDTO,
        } as OrderBookingWithoutBookingDTO,
        {
            appointmentDto: {
                date: toYmd(start_at),
                endTime: toHHMM12(finish_at),
                startTime: toHHMM12(start_at),
                serviceId,
                locationId,
                tenantId,
                staffAvailabilityId: staff_availability_id
            },
            clientEmail,
            tenantId,
        } as BookingDTO, recurring_dates || [], duration || 0, client_responses))
    } else {
        return await postApiRequest('/v1/orders/order-booking', {
            order: {
                clientEmail,
                clientFirstName,
                clientLastName,
                clientPhone,
                tenantId,
                membershipClientId,
                type: OrderType.SERVICE,
                couponCode: '',
                fullyPaid: false
            },
            booking: {
                appointmentDto: {
                    date: toYmd(start_at),
                    endTime: toHHMM12(finish_at),
                    startTime: toHHMM12(start_at),
                    serviceId,
                    locationId,
                    tenantId,
                    staffAvailabilityId: staff_availability_id
                },
                clientEmail,
                tenantId,
            },
            responses: client_responses?.map(mapClientResponseToDTO)
        })
    }

}
